import { Link } from 'react-router-dom';

import { ANCORAS, MARCA } from '@/features/landing/conteudo';
import { ROTAS } from '@/shared/lib/rotas';

/**
 * Rodapé. O ano é fixo de propósito: `new Date()` aqui faria o snapshot do
 * teste quebrar em 1º de janeiro, e um rodapé que só muda uma vez por ano não
 * justifica um valor dinâmico no bundle.
 */
const ANO = 2026;

export function LandingFooter() {
  return (
    <footer className="bg-background py-14">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            {/* Alturas diferentes por tema — ver o comentário no LandingHeader:
                os dois arquivos de logo têm enquadramentos distintos. */}
            <img
              src="/logo-nohra-light.png"
              alt={MARCA.nome}
              className="h-24 w-auto object-contain dark:hidden"
            />
            <img
              src="/logo-nohra-dark.png"
              alt={MARCA.nome}
              className="hidden h-12 w-auto object-contain dark:block"
            />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
              {MARCA.tagline}
            </p>
          </div>

          <div>
            <p className="text-sm font-semibold text-foreground">Plataforma</p>
            <ul className="mt-4 space-y-2.5">
              {ANCORAS.map((ancora) => (
                <li key={ancora.id}>
                  <a
                    href={`#${ancora.id}`}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {ancora.rotulo}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold text-foreground">Conta</p>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to={ROTAS.login}
                  className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                >
                  Entrar
                </Link>
              </li>
              <li>
                <Link
                  to={ROTAS.registro}
                  className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                >
                  Criar conta
                </Link>
              </li>
              <li>
                <Link
                  to={ROTAS.esqueciSenha}
                  className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                >
                  Esqueci a senha
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-border pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-muted-foreground">
            © {ANO} {MARCA.nome} — {MARCA.grupo}
          </p>
          <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-muted-foreground">
            <Link to={ROTAS.termosDeUso} className="transition-colors hover:text-foreground">
              Termos de uso
            </Link>
            <Link
              to={ROTAS.politicaDePrivacidade}
              className="transition-colors hover:text-foreground"
            >
              Política de privacidade
            </Link>
          </div>
        </div>

        <p className="mt-4 text-xs leading-relaxed text-muted-foreground">
          A NOHRA Clinic apoia a decisão do médico veterinário e não substitui o julgamento
          clínico do profissional.
        </p>
      </div>
    </footer>
  );
}
